import { FC } from 'react';
import Lottie from 'lottie-react';
import { Plus } from 'lucide-react';
import styled from 'styled-components';

import animationData from '@assets/animations/home.json';
import TouchableOpacity from '@components/buttons/TouchableOpacity';
import { PremierText } from '@components/text';

const Container = styled(TouchableOpacity)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const LogoIconContainer = styled.div`
  width: 64px;
  height: 64px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PlusIcon = styled(Plus)`
  color: ${({ theme }) => theme.colors.white};
`;

const Text = styled(PremierText)`
  font-size: ${({ theme }) => theme.fonts.fontSize.lg};
  letter-spacing: 0.04em;
`;

type Props = {
  onClick: () => void;
};

const GoLive: FC<Props> = ({ onClick }) => {
  return (
    <Container onClick={onClick}>
      <LogoIconContainer>
        <Lottie
          animationData={animationData}
          autoplay
          loop
          initialSegment={[65, 200]}
          style={{ width: 64, height: 64, position: 'absolute' }}
        />

        <PlusIcon size={28} />
      </LogoIconContainer>

      <Text>Go Live</Text>
    </Container>
  );
};

export default GoLive;
